import React from 'react'
import { FAQ } from 'components/FAQ/index.js'
import { TrackCaloriesFAQItems } from 'pages/TrackCalories/FAQ/Items/index.js'

export function TrackCaloriesFAQ () {
  return (
    // eslint-disable-next-line react/jsx-pascal-case
    <FAQ
      itemsComponent={<TrackCaloriesFAQItems />}
    />
  )
}
